var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c(
        "div",
        {
          class: _vm.cssMainClasses,
          attrs: {
            transition: "fade",
            "data-object-name": _vm.objectName,
            "data-object-id": _vm.objectId
          }
        },
        [
          _vm.selectable
            ? _c("div", { staticClass: "gallerycard-selector" }, [
                _c("i", {
                  staticClass: "brand-primary far fa-2x",
                  class: {
                    "fa-circle": !_vm.isSelected,
                    "fa-check-circle": _vm.isSelected
                  },
                  on: {
                    click: function($event) {
                      return _vm.onSelected($event)
                    },
                    dblclick: function($event) {
                      return _vm.onSelected($event)
                    }
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "gallerycard-thumbnail" }, [
            _c("div", { staticClass: "gallerycard-thumbnail-container-img" }, [
              _vm.src !== ""
                ? _c(
                    "a",
                    {
                      attrs: {
                        title: _vm.title,
                        href: _vm.fileViewSrc,
                        target: "contribution",
                        draggable: "false"
                      },
                      on: {
                        dragstart: function($event) {
                          $event.preventDefault()
                        }
                      }
                    },
                    [
                      !_vm.imageLoaded
                        ? _c("i", {
                            staticClass: "fa fa-spinner fa-spin fa-3x"
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("img", {
                        directives: [
                          {
                            name: "loadedifcomplete",
                            rawName: "v-loadedifcomplete",
                            value: _vm.imageLoaded,
                            expression: "imageLoaded"
                          }
                        ],
                        staticClass: "checkerboard",
                        attrs: {
                          src: _vm.src,
                          "data-magnify-src": _vm.zoom,
                          draggable: "false",
                          loading: "lazy"
                        },
                        on: {
                          load: _vm.onImageLoaded,
                          error: _vm.onImageError,
                          click: _vm.onImageClicked,
                          mouseover: _vm.onPreviewMouseOver,
                          mouseleave: _vm.onPreviewMouseLeave,
                          dragstart: function($event) {
                            $event.preventDefault()
                          }
                        }
                      })
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticStyle: {
                        background: "#efefef",
                        "min-height": "200px"
                      }
                    },
                    [_c("i", { staticClass: "fa fa-spinner fa-3x fa-spin" })]
                  )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "gallerycard-title" }, [
            _c("div", { staticClass: "gallerycard-title-table" }, [
              _c("div", { staticClass: "gallerycard-title-row" }, [
                _c(
                  "div",
                  { staticClass: "gallerycard-name gallerycard-title-cell" },
                  [
                    _c(
                      "span",
                      { staticClass: "title truncateTexte" },
                      [
                        _vm.metas &&
                        _vm.metas.values &&
                        _vm.metas.values.length > 0
                          ? _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  mouseover: function($event) {
                                    _vm.metasVisible = true
                                  },
                                  mouseout: function($event) {
                                    _vm.metasVisible = false
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-info-circle" })]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              effect: "light",
                              content: _vm.title,
                              placement: "bottom"
                            }
                          },
                          [
                            _c("span", {
                              domProps: { innerHTML: _vm._s(_vm.title) }
                            })
                          ]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "gallerycard-action gallerycard-title-cell" },
                  [
                    typeof _vm.status !== "undefined"
                      ? _c("span", {
                          staticClass: "status display-status",
                          style: { backgroundColor: _vm.status.color },
                          attrs: { title: _vm.status.label }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.withBtnEdit
                      ? _c("a", {
                          staticClass: "modify",
                          attrs: { href: "#" },
                          on: { click: _vm.btnEditClicked }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.withBtnView
                      ? _c("a", {
                          staticClass: "zoom",
                          attrs: { href: "#" },
                          on: { click: _vm.btnViewClicked }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.withBtnFileView &&
                    typeof _vm.fileViewSrc !== "undefined"
                      ? _c(
                          "a",
                          {
                            attrs: {
                              title: _vm.title,
                              href: _vm.fileViewSrc,
                              target: "contribution"
                            }
                          },
                          [_c("i", { staticClass: "far fa-eye fa-2x" })]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.withBtnActive
                      ? _c(
                          "a",
                          {
                            staticClass: "btn-load-form-data",
                            class: { "btn-load-form-data-active": _vm.active },
                            attrs: {
                              title: "Load form with this data",
                              href: "#"
                            },
                            on: { click: _vm.setActive }
                          },
                          [_c("i", { staticClass: "far fa-play-circle fa-2x" })]
                        )
                      : _vm._e()
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _vm.metas && _vm.metasVisible
            ? _c("div", { staticClass: "gallerycard-metas" }, [
                typeof _vm.metas.html !== "undefined"
                  ? _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.metas.html) }
                    })
                  : _vm._e(),
                _vm._v(" "),
                typeof _vm.metas.values !== "undefined"
                  ? _c("div", [
                      _c(
                        "ul",
                        _vm._l(_vm.metas.values, function(meta) {
                          return _c("li", { key: meta.name }, [
                            _c(
                              "span",
                              {
                                staticClass: "truncateTexte",
                                attrs: {
                                  "data-field-type": meta.type,
                                  title: "meta.name"
                                }
                              },
                              [
                                !meta.withoutLabel
                                  ? _c("span", { staticClass: "fieldname" }, [
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(meta.name)
                                        }
                                      }),
                                      _vm._v(" :\n            ")
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "fieldvalue",
                                  domProps: { innerHTML: _vm._s(meta.value) }
                                })
                              ]
                            )
                          ])
                        }),
                        0
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.hideBottomMetas
            ? _c("div", { staticClass: "gallerycard-bottom" }, [
                _c("div", { staticClass: "gallerycard-bottom-table" }, [
                  _c("div", { staticClass: "gallerycard-bottom-row" }, [
                    _vm.metas &&
                    _vm.metas.bottom_left &&
                    _vm.metas.bottom_left !== ""
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "gallerycard-bottom-cell gallerycard-bottom-cell-left"
                          },
                          [
                            _c("span", {
                              staticClass: "assetType",
                              domProps: {
                                innerHTML: _vm._s(_vm.metas.bottom_left)
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.metas &&
                    _vm.metas.bottom_right &&
                    _vm.metas.bottom_right !== ""
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "gallerycard-bottom-cell gallerycard-bottom-cell-right"
                          },
                          [
                            _c("span", {
                              staticClass: "assetType",
                              domProps: {
                                innerHTML: _vm._s(_vm.metas.bottom_right)
                              }
                            })
                          ]
                        )
                      : _vm._e()
                  ])
                ])
              ])
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }